import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "../../../constants";
import SectionNewspappersAdmin from "components/Sections/SectionNewspappersAdmin"

const PageGetAllNewspappers = () => {
  const [newspappers, setNewspappers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [newspappersRes] = await Promise.all([
          fetch(`${BACKEND_URL}/newspappers`),
        ]);

        const [newspappersData] = await Promise.all([
          newspappersRes.json()
        ]);

        if (!newspappersData.error) {
          setNewspappers(newspappersData.result);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="nc-PageHomeDemo6 relative [ nc-section-rounded-md ]">
      <div className="relative overflow-hidden">
        <div className="container relative">
          <h1
            className="text-2xl md:text-3xl lg:text-4xl font-semibold my-12"
          >
            Wszystkie gazety
          </h1>

          <SectionNewspappersAdmin
            posts={newspappers}
          />
        </div>
      </div>
    </div>
  );
};

export default PageGetAllNewspappers;